import { Avatar, Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, Tab, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import MUIButton from "../../reusable_components/components/MUIButton"
import { useGetGridDatasMutation, useGetMappedClientMutation, useInternalReferralListMutation, useReferralListMutation } from "../../redux/clients/clients.api"
import { Link, useNavigate } from "react-router-dom"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import AddIcon from '@mui/icons-material/Add';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useGetClientDropdownQuery } from "../../redux/jobpostings/jobpostings.api"
import dayjs from "dayjs"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import SearchIconLg from "../../assets/Icons/SearchIcon"
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"
import { useSelector } from "react-redux"
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { TabContext, TabList, TabPanel } from "@mui/lab"
import ClearIcon from '@mui/icons-material/Clear';

const Clients = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [searchKeyword, setSearchKeyword] = useState(commonFilter?.clients?.clientName || "")
    const [filterByPhone, setFilterByPhone] = useState(commonFilter?.clients?.phone || "")
    const [filterByEmail, setFilterByEmail] = useState(commonFilter?.clients?.email || "")
    const [filterByAddress, setFilterByAddress] = useState(commonFilter?.clients?.address || "")
    const [filterByCity, setFilterByCity] = useState(commonFilter?.clients?.city || "")
    const [selectedStatus, setSelectedStatus] = useState(commonFilter?.clients?.status || "")
    const [selectedStatusName, setSelectedStatusName] = useState(commonFilter?.clients?.selectedstatus || "")
    const [filterByCreatedDate, setFilterByCreatedDate] = useState(commonFilter?.clients?.fromDate ? dayjs(commonFilter.clients.fromDate) : null);
    const [filterByToDate, setFilterByToDate] = useState(commonFilter?.clients?.toDate ? dayjs(commonFilter.clients.toDate) : null);


    const { Profile } = useSelector((state) => state.common)
    const userRole = Profile?.profile?.role
    const isExternal = Profile?.profile?.isExternalRecruiter



    const navigate = useNavigate()
    const [client, setClient] = useState("")
    const [mappage, setMapPage] = useState(+localStorage.getItem("clientMappedPage") || 1)
    const [clientTableDatas, setClientTableDatas] = useState([])
    const [mappedclientTableDatas, setMappedClientTableDatas] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [sortingColumn, setSortingColumn] = useState("created_date")
    const [sortingDirection, setSortingDirection] = useState("DESC")
    const [open, setOpen] = useState(false)
    const [triggerAPI, setTriggerAPI] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [value, setValue] = useState(localStorage.getItem("clientTab") || '0')


    const [openSelectStatus, setOpenSelectStatus] = useState(false)

    // Pagination
    const [page, setPage] = useState(+localStorage.getItem("clientNewPage") || 1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [mappedtotalDataCount, setMappedTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [mappedRowsPerPage, setMappedRowsPerPage] = useState(10)
    const { Snackbar } = useContext(SnackbarContext)
    const [shouldFetch, setShouldFetch] = useState(false);

    const [getTableDatas] = useGetGridDatasMutation()
    const { data: getClientDropdownlist } = useGetClientDropdownQuery()
    const [mappedClient] = useGetMappedClientMutation()
    const [referralList] = useReferralListMutation()
    const [InternalReferralList] = useInternalReferralListMutation()

    const handleOpen = () => {
        if (chips.length === 0) {
            setClient("");
            setFilterByPhone("");
            setFilterByEmail("");
            setFilterByAddress("");
            setFilterByCity("");
            setSelectedStatus("");
            setSelectedStatusName("");
            setFilterByCreatedDate(null);
            setFilterByToDate(null);
            setOpen(true)

        } else {
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    // const handleClientName = (e) => {
    //     const value = e.target.value
    //     setClient(value)
    // }

    const handleFilterByPhone = (e) => {
        const value = e.target.value
        setFilterByPhone(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                phone: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleFilterByEmail = (e) => {
        const value = e.target.value
        setFilterByEmail(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                email: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleFilterByCreatedDate = (value) => {
        setFilterByCreatedDate(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                fromDate: value ? value.toISOString() : null,
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
        if (filterByToDate && filterByToDate <= value) {
            setFilterByToDate(null)
        }
    }

    const handleFilterByToDate = (value) => {
        setFilterByToDate(value)
        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                toDate: value ? value.toISOString() : null,
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }

        return dayjs(fromDate)?.add(1, 'day')
    }

    const handleFilterByAddress = (e) => {
        const value = e.target.value
        setFilterByAddress(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                address: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    const handleFilterByCity = (e) => {
        const value = e.target.value
        setFilterByCity(value)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                city: value
            }
        }

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter))
    }

    useEffect(() => {
        const clients = commonFilter?.clients;

        const hasValue = clients && Object.values(clients).some(value =>
            value !== "" && value !== 0 && value !== null && value !== undefined
        );

        if (hasValue) {
            setShouldFetch(hasValue);
        } else {
            setShouldFetch(false)
        }
    }, [])

    const clientStatus = [
        {
            statusName: 'Approved',
            statusId: 1
        },
        {
            statusName: 'Rejected',
            statusId: 2
        },
        {
            statusName: 'Pending',
            statusId: 3
        }
    ]

    const handleStatusChange = (e) => {
        const value = e.target.value
        setSelectedStatus(value)

        const statusName = clientStatus?.find((id) => id?.statusId === value)
        setSelectedStatusName(statusName?.statusName)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        // 2. Update the clientId inside dashbord
        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                status: value,
                selectedstatus: statusName?.statusName
            }
        };

        // 3. Store the updated object back in localStorage
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
        setPage(1)
        setTriggerAPI(true)
        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        // 2. Update the clientId inside dashbord
        const updatedFilter = {
            ...currentFilter,
            clients: {
                ...currentFilter.clients,
                clientName: value
            }
        };

        // 3. Store the updated object back in localStorage
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleSort = (columnName) => {
        if (sortingColumn === columnName) {
            setSortingDirection((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'))
            setTriggerAPI(true)
        } else {
            setSortingColumn(columnName)
            setSortingDirection('ASC')
        }
    }

    const handleClearFilter = () => {
        setClient("")
        setFilterByPhone("")
        setSelectedStatus("")
        setFilterByEmail("")
        setFilterByCreatedDate(null)
        setFilterByToDate(null)
        setFilterByAddress("")
        setFilterByCity("")
        setSelectedStatusName("")
        setTriggerAPI(true)
        setShowClearFilter(false)
    }

    // Pagination Functionalities
    const handleChangePage = (e, newPage) => {
        localStorage.setItem("clientNewPage", newPage)
        setPage(newPage)
        setTriggerAPI(true)
    }

    const handleMappedPage = (e, newPage) => {
        localStorage.setItem("clientMappedPage", newPage)
        setMapPage(newPage)
        setTriggerAPI(true)
    }

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    }

    const formatDate = (date = new Date()) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const handleEditClientNav = (item) => {
        const clientId = item?.ClientId || item?.clientId;

        navigate('/client-view', {
            state: {
                clientName: item?.clientName,
                clientId: clientId,
                isReferralClient: item?.isReferral,
                clientCreatedBy: item?.clientCreatedBy,
                createdDate: item?.createdDate,
                clientStatus: item?.clientStatusName
            }
        });
    };

    // const handleEditMappedClientNav = (item) => {
    //     navigate(`/client-view`, {
    //         state: {
    //             mappedclientName: item?.clientName, mappedclientId: item?.ClientId, mappedisReferralClient: item?.isReferral, mappedclientCreatedBy: item?.clientCreatedBy,
    //             mappedcreatedDate: item?.createdDate, mappedclientStatus: item?.clientStatusName
    //         }
    //     }
    //     )
    // }

    const getGridDatas = async () => {
        try {
            const payload = {
                clientName: searchKeyword ? searchKeyword : client,
                address: filterByAddress,
                email: filterByEmail,
                status: selectedStatus,
                city: filterByCity,
                phone: filterByPhone,
                fromDate: filterByCreatedDate ? dayjs(filterByCreatedDate).format('YYYY-MM-DD') : '',
                toDate: filterByToDate ? dayjs(filterByToDate).format('YYYY-MM-DD') : '',
                sortingDirection: sortingDirection,
                sortingColumn: sortingColumn,
                page: searchKeyword === '' ? (page - 1) : 0,
                size: rowsPerPage,
            }
            if (userRole === "recruiter" && isExternal === "Y") {
                setShowTableLoader(true)
                const response = await referralList(payload).unwrap()
                setShowTableLoader(false)
                setClientTableDatas(response?.response?.data)
                setTotalDataCount(response?.response?.Count)

            } else if (userRole === "recruiter" && isExternal === "N") {
                setShowTableLoader(true)
                const response = await InternalReferralList(payload).unwrap()
                setShowTableLoader(false)
                setClientTableDatas(response?.response?.data)
                setTotalDataCount(response?.response?.Count)
            } else {
                setShowTableLoader(true)
                const response = await getTableDatas(payload).unwrap()
                setShowTableLoader(false)
                setClientTableDatas(response?.response?.data)
                setTotalDataCount(response?.response?.Count)
            }


        } catch (err) {
            Snackbar("Network Error", 'error')
            setShowTableLoader(false)
        }
    }

    const mappedDatas = async () => {
        try {
            const payload = {
                page: mappage - 1 || 0,
                size: mappedRowsPerPage,
                sortingColumn: "mappedDate",
                sortingDirection: sortingDirection,
                clientName: searchKeyword ? searchKeyword : "",
            }
            if (userRole === "recruiter" && isExternal === "Y") {
                setShowTableLoader(true)
                const response = await mappedClient(payload).unwrap()
                setShowTableLoader(false)
                setMappedClientTableDatas(response?.response?.clients)
                setMappedTotalDataCount(response?.response?.totalRecords)

            } else {
                setShowTableLoader(true)
                const response = await getTableDatas(payload).unwrap()
                setShowTableLoader(false)
                setMappedClientTableDatas(response?.response?.clients)
                setMappedTotalDataCount(response?.response?.totalRecords)
            }


        } catch (err) {
            Snackbar("Network Error", 'error')
            setShowTableLoader(false)
        }
    }
    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {
        const updatedChip = ([
            {
                label: client,
                onDelete: () => {
                    setClient('')
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== client))
                }
            },
            {
                label: filterByPhone,
                onDelete: () => {
                    setFilterByPhone('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                phone: ''
                            }
                        })
                    )
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByPhone))
                }
            },
            {
                label: filterByEmail,
                onDelete: () => {
                    setFilterByEmail('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                email: ''
                            }
                        })
                    )
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByEmail))

                }
            },
            {
                label: filterByAddress,
                onDelete: () => {
                    setFilterByAddress('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                address: ''
                            }
                        })
                    )
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByAddress))

                }
            },
            {
                label: filterByCity,
                onDelete: () => {
                    setFilterByCity('')
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                city: ''
                            }
                        })
                    )
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== filterByCity))

                }
            },
            {
                label: selectedStatusName,
                onDelete: () => {
                    setSelectedStatusName("")
                    setSelectedStatus("")
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                status: ''
                            }
                        })
                    )
                    setTriggerAPI(true)
                    setChips(prevChips => prevChips?.filter(chips => chips?.label !== selectedStatusName))

                }
            },
            filterByCreatedDate && {
                label: dayjs(filterByCreatedDate).format('DD-MM-YYYY'),
                onDelete: () => {
                    setFilterByCreatedDate(null);
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                ...commonFilter.clients,
                                fromDate: null,
                            },
                        })
                    );
                    setFilterByToDate(null);
                    setTriggerAPI(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(filterByCreatedDate).format('DD-MM-YYYY')));
                },
            },
            filterByToDate && {
                label: dayjs(filterByToDate).format('DD-MM-YYYY'),
                onDelete: () => {
                    setFilterByToDate(null);
                    localStorage.setItem(
                        'commonsearchfilter',
                        JSON.stringify({
                            ...commonFilter,
                            clients: {
                                ...commonFilter.clients,
                                toDate: null,
                            },
                        })
                    );
                    setTriggerAPI(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(filterByToDate).format('DD-MM-YYYY')));
                },
            },
        ]).filter(Boolean);

        setChips(updatedChip);
        setTriggerAPI(true);
        setShowClearFilter(true);
    };

    useEffect(() => {
        if (value === "0") {
            getGridDatas()
        } else {
            mappedDatas()
        }
    }, [value, sortingDirection, searchKeyword, mappage])

    useEffect(() => {
        if (triggerAPI && value === "0") {
            getGridDatas()
            handleClose()
            setTriggerAPI(false)
        }
    }, [getTableDatas, client, selectedStatus, filterByPhone, filterByEmail, filterByCreatedDate, filterByAddress, filterByCity, page, rowsPerPage, sortingDirection, triggerAPI, searchKeyword])

    const filteredTableDatas = clientTableDatas

    // const chips = [
    //     {
    //         label: client,
    //         onDelete: () => {
    //             setClient('')
    //             setTriggerAPI(true)
    //         }
    //     },
    //     {
    //         label: filterByPhone,
    //         onDelete: () => {
    //             setFilterByPhone('')
    //             setTriggerAPI(true)
    //         }
    //     },
    //     {
    //         label: filterByEmail,
    //         onDelete: () => {
    //             setFilterByEmail('')
    //             setTriggerAPI(true)
    //         }
    //     },
    //     {
    //         label: filterByAddress,
    //         onDelete: () => {
    //             setFilterByAddress('')
    //             setTriggerAPI(true)
    //         }
    //     },
    //     {
    //         label: filterByCity,
    //         onDelete: () => {
    //             setFilterByCity('')
    //             setTriggerAPI(true)
    //         }
    //     },
    //     {
    //         label: selectedStatusName,
    //         onDelete: () => {
    //             setSelectedStatusName("")
    //             setSelectedStatus("")
    //             setTriggerAPI(true)
    //         }
    //     },
    //     filterByCreatedDate && {
    //         label: dayjs(filterByCreatedDate)?.format('DD-MM-YYYY'),
    //         onDelete: () => {
    //             setFilterByCreatedDate(null)
    //             setFilterByToDate(null)
    //             setTriggerAPI(true)
    //         }
    //     },
    //     filterByToDate && {
    //         label: dayjs(filterByToDate)?.format('DD-MM-YYYY'),
    //         onDelete: () => {
    //             setFilterByToDate(null)
    //             setTriggerAPI(true)
    //         }
    //     }
    // ]

    useEffect(() => {
        if (chips?.every((name) => !name?.label)) {
            setShowClearFilter(false)
        }
    }, [triggerAPI])

    const statusOptions = [
        {
            id: 1,
            label: 'Approved'
        },
        {
            id: 2,
            label: 'Rejected'
        },
        {
            id: 3,
            label: 'Pending'
        },
    ]

    useEffect(() => {
        if (shouldFetch && value === "0") {
            letsFilterDatas();
            setShouldFetch(false)
        }


    }, [page, shouldFetch, searchKeyword]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchKeyword("")
        localStorage.setItem("clientTab", newValue);
    };

    return (
        <Box className='container'>

            {/* Container 1 */}
            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid2 item container sx={{ display: 'flex', gap: '15px', marginTop: "15px" }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Typography className="title"> {userRole === "recruiter" ? "Refer a Client" : "Clients"} </Typography>
                        <div style={{ display: 'flex', gap: '20px' }}>

                            <Box>
                                <TextField
                                    className="textfields"
                                    size="small"
                                    placeholder='Search By Client'
                                    slotProps={{
                                        input: {
                                            startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                        },
                                    }}
                                    value={searchKeyword}
                                    onChange={handleSearchKeywordChange}
                                />
                            </Box>

                            <MUIButton title={userRole === "recruiter" ? "Refer a Client" : "Add Client"}
                                startIcon={<AddIcon sx={{ marginRight: '-5px' }} />} component={Link} to='/client-add' sx={{ backgroundColor: '#7F56D9', width: '120px' }} />
                        </div>
                    </div>
                </Grid2>

                {/* Table Container */}
                <TabContext value={value}>
                    {
                        (userRole === 'recruiter' && isExternal === "Y") &&
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList
                                onChange={handleChange}
                                aria-label="Overview and Candidates tabs"
                                textColor="primary"
                                indicatorColor="secondary"
                            >
                                <Tab
                                    label="Refer a Client"
                                    value="0"
                                    className="tabs"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: value === "0" ? 'bold' : 'normal',
                                        transition: 'all 0.3s ease',
                                    }}
                                />
                                < Tab
                                    label="Mapped Client"
                                    value="1"
                                    className="tabs"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: value === "1" ? 'bold' : 'normal',
                                        transition: 'all 0.3s ease',
                                    }}
                                />
                            </TabList>
                        </Box>
                    }
                    <TabPanel value="0" sx={{ display: 'flex', padding: "0px" }}>
                        <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid #E9EAEB', borderRadius: '10px', marginTop: '20px' }} elevation={0}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={100} sx={{ padding: '8px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '14px' }}>
                                                <div>
                                                    {showClearFilter && (
                                                        chips?.map((item, index) => (
                                                            item?.label && (
                                                                <Chip key={index} label={item?.label} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={item?.onDelete} className='Chip' />
                                                            )
                                                        ))
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', gap: '14px' }}>
                                                    <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '18px !important' }} />} sx={{ color: '#6941C6', fontWeight: 600, width: '130px' }} />
                                                    {(client || filterByPhone || filterByEmail || filterByAddress || filterByCity || selectedStatus || filterByCreatedDate || filterByToDate) && showClearFilter && (
                                                        <MUICancelButton title='Clear Filter' onClick={handleClearFilter} sx={{ width: '100px' }} />
                                                    )}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">
                                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: '20%' }}
                                                onClick={() => handleSort("created_date")}
                                            >
                                                Name
                                                <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                            </div>
                                        </TableCell>
                                        <TableCell className="tableHeadersCell"> Address </TableCell>
                                        <TableCell className="tableHeadersCell"> Phone </TableCell>
                                        <TableCell className='tableHeadersCell_2'>Sourced By</TableCell>
                                        <TableCell className='tableHeadersCell_2'>Permanent Reward</TableCell>
                                        <TableCell className='tableHeadersCell_2'>Contract Reward</TableCell>
                                        {/* <TableCell className='tableHeadersCell_2'>Is Referral</TableCell> */}
                                        <TableCell className="tableHeadersCell"> Created Date </TableCell>
                                        <TableCell className="tableHeadersCell"> Status </TableCell>
                                    </TableRow>
                                </TableHead>



                                {!showTableLoader ? (
                                    filteredTableDatas?.length > 0 ? (
                                        <TableBody>
                                            {filteredTableDatas?.map((item, index) => {
                                                const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                                const backgroundColor = colors[index % colors?.length]

                                                return (
                                                    <TableRow key={item?.ClientId}
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >

                                                        <TableCell className="tableBodyCell" sx={{ color: '#53389E', cursor: 'pointer', fontWeight: 600 }} onClick={() => handleEditClientNav(item)}>{item.clientName}<br>
                                                        </br> <span style={{ color: '#535862', fontSize: '11px', fontWeight: 400 }}>{item.clientEmail ? item.clientEmail : 'NA'}</span>
                                                        </TableCell>
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>{item.clientAddress ? item.clientAddress : 'NA'} <br />{item.city} - {item.state}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>{item.clientAddress ? item.clientAddress : 'NA'} <br />{item.city} - {item.state}</TableCell>
                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item.clientPhone}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item.clientPhone}</TableCell>

                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell">
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{item?.sourcedUserName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                                                                        <Typography className="tableBodyCell" sx={{ color: '#535862', borderBottom: 'none !important' }}>{item?.sourcedUserName}<span style={{ color: '#5417cd', fontWeight: 600, marginLeft: '4px' }}>{item?.isReferral === "Y" ? "(BA)" : ""}</span><br></br><span style={{ color: '#535862' }}>{item?.sourcedUserEmail}</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: '#535862', fontSize: '14px' }}>{"?"}</Avatar>
                                                                        <Typography className="tableBodyCells" sx={{ color: '#535862' }}>******<br></br><span style={{ color: '#535862' }}>***********</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                : <TableCell className='tableBodyCell'>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{item?.sourcedUserName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                                                                        <Typography className='tableBodyCells' sx={{ color: "#181D27" }}>{item?.sourcedUserName}<span style={{ color: '#5417cd', fontWeight: 600, marginLeft: '4px' }}>{item?.isReferral === "Y" ? "(BA)" : ""}</span><br></br><span style={{ color: '#535862' }}>{item?.sourcedUserEmail}</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                        }
                                                        {
                                                            userRole === "recruiter" ? (
                                                                item?.clientCreatedBy === "You" ? (
                                                                    <TableCell className="tableBodyCell" sx={{ color: '#181D27', width: '7%', textAlign: 'left' }}>
                                                                        {item?.isReferral === 'N' ? (
                                                                            "NA"
                                                                        ) : (
                                                                            !item?.clientRewardType ? "NA" :
                                                                                item?.clientRewardType === "FC" ? (
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                        <Typography className="tableBodyCell" sx={{ textAlign: 'left' }}>
                                                                                            {item?.clientRewardAmount || "NA"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                ) : (
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                        <Typography className="tableBodyCell" sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                            {item?.clientRewardPct ? `${item?.clientRewardPct}%` : "NA"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                )
                                                                        )}
                                                                    </TableCell>
                                                                    
                                                                ) : (
                                                                    <TableCell className="tableBodyCell" sx={{ color: '#535862', width: '7%', textAlign: 'left' }}>
                                                                        ******
                                                                    </TableCell>
                                                                )
                                                            ) : (
                                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27', width: '7%', textAlign: 'left' }}>
                                                                    {item?.isReferral === 'N' ? (
                                                                        "NA"
                                                                    ) : (
                                                                        !item?.clientRewardType ? "-" :
                                                                            item?.clientRewardType === "FC" ? (
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                        {item?.clientRewardAmount || "NA"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            ) : (
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <Typography sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                        {item?.clientRewardPct ? `${item?.clientRewardPct}%` : "NA"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            )
                                                                    )}
                                                                </TableCell>
                                                            )
                                                        }

                                                          {
                                                            userRole === "recruiter" ? (
                                                                item?.clientCreatedBy === "You" ? (
                                                                    <TableCell className="tableBodyCell" sx={{ color: '#181D27', width: '7%', textAlign: 'left' }}>
                                                                        {item?.isReferral === 'N' ? (
                                                                            "NA"
                                                                        ) : (
                                                                            !item?.contractRewardType ? "NA" :
                                                                                item?.contractRewardType === "FC" ? (
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                        <Typography className="tableBodyCell" sx={{ textAlign: 'left' }}>
                                                                                            {item?.contractRewardAmount || "NA"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                ) : (
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                        <Typography className="tableBodyCell" sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                            {item?.contractRewardPct ? `${item?.contractRewardPct}%` : "NA"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                )
                                                                        )}
                                                                    </TableCell>
                                                                    
                                                                ) : (
                                                                    <TableCell className="tableBodyCell" sx={{ color: '#535862', width: '7%', textAlign: 'left' }}>
                                                                        ******
                                                                    </TableCell>
                                                                )
                                                            ) : (
                                                                <TableCell className="tableBodyCell" sx={{ color: '#181D27', width: '7%', textAlign: 'left' }}>
                                                                    {item?.isReferral === 'N' ? (
                                                                        "NA"
                                                                    ) : (
                                                                        !item?.contractRewardType ? "-" :
                                                                            item?.contractRewardType === "FC" ? (
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                    <Typography sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                        {item?.contractRewardAmount || "NA"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            ) : (
                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                    <Typography sx={{ textAlign: 'left', fontSize: '12.5px !important' }}>
                                                                                        {item?.contractRewardPct ? `${item?.contractRewardPct}%` : "NA"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            )
                                                                    )}
                                                                </TableCell>
                                                            )
                                                        }

                                                        {/* {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ Color: '#181D27', width: '7%' }}>{item.isReferral === "N" ? 'No' : 'Yes'}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862', width: '7%' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ Color: '#181D27', width: '7%' }}>{item.isReferral === "N" ? 'No' : 'Yes'}</TableCell>

                                                        } */}
                                                        <TableCell className="tableBodyCell" sx={{ width: "10%", color: '#535862' }}>{formatDate(item.createdDate)}</TableCell>
                                                        <TableCell className="tableBodyCell">
                                                            <Tooltip title={item?.clientStatusName === "Rejected" ? item?.feedBack : ""}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}>
                                                                <span className={`clientStatus-badge ${item?.clientStatusName?.toLowerCase()}`}>{item.clientStatusName}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            )}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {(totalDataCount / rowsPerPage) > 1 && (
                                    <TableRow>
                                        <TableCell colSpan={100}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleChangePage(null, page - 1)}
                                                    disabled={page === 1}
                                                    sx={{ height: '36px' }}
                                                />

                                                <Pagination
                                                    page={page}
                                                    onChange={handleChangePage}
                                                    count={Math.ceil(totalDataCount / rowsPerPage)}
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    shape="rounded"
                                                    hideNextButton
                                                    hidePrevButton
                                                />

                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleChangePage(null, page + 1)}
                                                    disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                        </Paper>
                    </TabPanel>
                    <TabPanel value="1" sx={{ display: 'flex', padding: "0px" }}>
                        <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid #E9EAEB', borderRadius: '10px', marginTop: '20px' }} elevation={0}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={100} sx={{ padding: '8px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '14px' }}>
                                                <div>
                                                    {showClearFilter && (
                                                        chips?.map((item, index) => (
                                                            item?.label && (
                                                                <Chip key={index} label={item?.label} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={item?.onDelete} className='Chip' />
                                                            )
                                                        ))
                                                    )}
                                                </div>
                                                {
                                                    value === "0" && (
                                                        <div style={{ display: 'flex', gap: '14px' }}>
                                                            <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '18px !important' }} />} sx={{ color: '#6941C6', fontWeight: 600, width: '130px' }} />
                                                            {(client || filterByPhone || filterByEmail || filterByAddress || filterByCity || selectedStatus || filterByCreatedDate || filterByToDate) && showClearFilter && (
                                                                <MUICancelButton title='Clear Filter' onClick={handleClearFilter} sx={{ width: '100px' }} />
                                                            )}
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="tableHeadersCell">
                                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: '20%' }}
                                                onClick={() => handleSort("created_date")}
                                            >
                                                Name
                                                <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                            </div>
                                        </TableCell>
                                        <TableCell className="tableHeadersCell"> Address </TableCell>
                                        <TableCell className="tableHeadersCell"> Phone </TableCell>
                                        <TableCell className='tableHeadersCell_2'>Sourced By</TableCell>
                                        <TableCell className='tableHeadersCell_2'>Rewards</TableCell>
                                        <TableCell className='tableHeadersCell_2'>Is Referral</TableCell>
                                        <TableCell className="tableHeadersCell"> Mapped Date </TableCell>
                                        {/* <TableCell className="tableHeadersCell"> Created Date </TableCell> */}
                                        <TableCell className="tableHeadersCell"> Status </TableCell>
                                    </TableRow>
                                </TableHead>



                                {!showTableLoader ? (
                                    mappedclientTableDatas?.length > 0 ? (
                                        <TableBody>
                                            {mappedclientTableDatas?.map((item, index) => {
                                                const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                                const backgroundColor = colors[index % colors?.length]

                                                return (
                                                    <TableRow key={item?.ClientId}
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >

                                                        <TableCell className="tableBodyCell" sx={{ color: '#53389E', cursor: 'pointer', fontWeight: 600 }} onClick={() => handleEditClientNav(item)}>{item.clientName}<br>
                                                        </br>
                                                            {
                                                                userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                    <span style={{ color: '#535862', fontSize: '11px', fontWeight: 400 }}>{item.clientEmail ? item.clientEmail : 'NA'}</span> :
                                                                    <span style={{ color: '#535862', fontSize: '11px', fontWeight: 400 }}>******</span> :
                                                                    <span style={{ color: '#535862', fontSize: '11px', fontWeight: 400 }}>{item.clientEmail ? item.clientEmail : 'NA'}</span>
                                                            }
                                                        </TableCell>
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>{item.clientAddress ? item.clientAddress : 'NA'} <br />{item.city} - {item.state}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>{item.clientAddress ? item.clientAddress : 'NA'} <br />{item.city} - {item.state}</TableCell>
                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item.clientPhone}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ Color: '#181D27' }}>{item.clientPhone}</TableCell>

                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell">
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{item?.sourcedUserName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                                                                        <Typography className="tableBodyCell" sx={{ color: '#535862', borderBottom: 'none !important' }}>{item?.sourcedUserName}<br></br><span style={{ color: '#535862' }}>{item?.sourcedUserEmail}</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862' }}>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: '#535862', fontSize: '14px' }}>{"?"}</Avatar>
                                                                        <Typography className="tableBodyCells" sx={{ color: '#535862' }}>******<br></br><span style={{ color: '#535862' }}>***********</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                : <TableCell className='tableBodyCell'>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                                                                        <Avatar alt={item?.firstName || "NA"} sx={{ width: '32px', height: '32px', backgroundColor: backgroundColor, fontSize: '14px' }}>{item?.sourcedUserName?.charAt(0)?.toUpperCase() || "?"}</Avatar>
                                                                        <Typography className='tableBodyCells' sx={{ color: "#181D27" }}>{item?.sourcedUserName}<br></br><span style={{ color: '#535862' }}>{item?.sourcedUserEmail}</span></Typography>
                                                                    </Box>
                                                                </TableCell>
                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell sx={{ Color: '#181D27', width: '7%' }}>
                                                                    {item?.isReferral === 'N' ? (
                                                                        <TableCell sx={{ borderBottom: 'none !important' }}>NA</TableCell>
                                                                    ) : (
                                                                        <>

                                                                            {
                                                                                !item?.clientRewardType ? "-" : item?.clientRewardType === "FC" ?
                                                                                    (
                                                                                        <TableCell sx={{ borderBottom: 'none !important' }}>
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                                <Typography sx={{ fontSize: '12.5px', borderBottom: 'none !important' }}>
                                                                                                    {item?.clientRewardAmount}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    ) :
                                                                                    (
                                                                                        <TableCell sx={{ borderBottom: 'none !important' }}>
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                                <Typography sx={{ fontSize: '12.5px', borderBottom: 'none !important' }}>{item?.clientRewardPct}%</Typography>
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    )
                                                                            }
                                                                        </>
                                                                    )
                                                                    }
                                                                </TableCell>
                                                                : <TableCell sx={{ color: '#535862', width: '7%' }}>******</TableCell>
                                                                : <TableCell sx={{ Color: '#181D27', width: '7%' }}>
                                                                    {item?.isReferral === 'N' ? (
                                                                        <TableCell className="tableBodyCell" sx={{ borderBottom: 'none !important' }}>NA</TableCell>
                                                                    ) : (
                                                                        <>

                                                                            {
                                                                                !item?.clientRewardType ? "-" : item?.clientRewardType === "FC" ?
                                                                                    (
                                                                                        <TableCell className="tableBodyCell" sx={{ borderBottom: 'none !important' }}>
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                                <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                                                                <Typography sx={{ fontSize: '12.5px', borderBottom: 'none !important' }}>
                                                                                                    {item?.clientRewardAmount}
                                                                                                </Typography>
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    ) :
                                                                                    (
                                                                                        <TableCell>
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                                <Typography sx={{ fontSize: '12.5px', borderBottom: 'none !important' }}>{item?.clientRewardPct}%</Typography>
                                                                                            </Box>
                                                                                        </TableCell>
                                                                                    )
                                                                            }
                                                                        </>
                                                                    )
                                                                    }
                                                                </TableCell>
                                                        }
                                                        {
                                                            userRole === "recruiter" ? item?.clientCreatedBy === "You" ?
                                                                <TableCell className="tableBodyCell" sx={{ Color: '#181D27', width: '7%' }}>{item.isReferral === "N" ? 'No' : 'Yes'}</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ color: '#535862', width: '7%' }}>******</TableCell>
                                                                : <TableCell className="tableBodyCell" sx={{ Color: '#181D27', width: '7%' }}>{item.isReferral === "N" ? 'No' : 'Yes'}</TableCell>

                                                        }
                                                        <TableCell className="tableBodyCell" sx={{ width: "10%", color: '#535862' }}>{formatDate(item.mappedDate)}</TableCell>
                                                        {/* <TableCell className="tableBodyCell" sx={{ width: "10%", color: '#535862' }}>{formatDate(item.createdDate)}</TableCell> */}
                                                        <TableCell className="tableBodyCell">
                                                            <Tooltip title={item?.clientStatusName === "Rejected" ? item?.feedBack : ""}
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}>
                                                                <span className={`clientStatus-badge ${item?.clientStatusName?.toLowerCase()}`}>{item.clientStatusName}</span>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            )}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography className="emptydatas">No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Box className='tableloader'>
                                                <TableLoader />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {(mappedtotalDataCount / mappedRowsPerPage) > 1 && (
                                    <TableRow>
                                        <TableCell colSpan={100}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MUICancelButton
                                                    title='Previous'
                                                    startIcon={<ArrowBackIcon sx={{ color: mappage === 1 ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleMappedPage(null, mappage - 1)}
                                                    disabled={mappage === 1}
                                                    sx={{ height: '36px' }}
                                                />

                                                <Pagination
                                                    page={mappage}
                                                    onChange={handleMappedPage}
                                                    count={Math.ceil(mappedtotalDataCount / mappedRowsPerPage)}
                                                    siblingCount={1}
                                                    boundaryCount={1}
                                                    shape="rounded"
                                                    hideNextButton
                                                    hidePrevButton
                                                />

                                                <MUICancelButton
                                                    title='Next'
                                                    startIcon={<ArrowForwardIcon sx={{ color: mappage === Math.ceil(mappedtotalDataCount / mappedRowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                    onClick={() => handleMappedPage(null, mappage + 1)}
                                                    disabled={mappage === Math.ceil(mappedtotalDataCount / mappedRowsPerPage)}
                                                    sx={{ height: '36px' }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </Table>
                        </Paper>
                    </TabPanel>
                </TabContext>

                {/* More filters Dialog */}
                <Dialog
                    open={open}
                    scroll="paper"
                    maxWidth='md'
                    className="sidePopup"
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 550 }}>
                        Filters
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={() => setOpen(false)} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                    {/* <Grid2 item>
                                            <InputLabel className="inputlabels">Client Name</InputLabel>
                                            <TextField
                                                className="textfields"
                                                value={client || ""}
                                                onChange={handleClientName}
                                                placeholder='Search Client Name'
                                            />
                                        </Grid2> */}

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Phone</InputLabel>
                                        <TextField
                                            className="textfields"
                                            placeholder='Search By Phone'
                                            value={filterByPhone}
                                            onChange={handleFilterByPhone}
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Client Email</InputLabel>
                                        <TextField
                                            className="textfields"
                                            placeholder='Search By Client Email'
                                            value={filterByEmail}
                                            onChange={handleFilterByEmail}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Address</InputLabel>
                                        <TextField
                                            className="textfields"
                                            placeholder='Search By Address'
                                            value={filterByAddress}
                                            onChange={handleFilterByAddress}
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">City</InputLabel>
                                        <TextField
                                            className="textfields"
                                            placeholder='Search By City'
                                            value={filterByCity}
                                            onChange={handleFilterByCity}
                                        />
                                    </Grid2>


                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Status</InputLabel>
                                        <Select
                                            className="dropdown"
                                            placeholder="Select By Status"
                                            value={selectedStatus || ""}
                                            onChange={handleStatusChange}
                                            open={openSelectStatus}
                                            onOpen={() => setOpenSelectStatus(true)}
                                            onClose={() => setOpenSelectStatus(false)}
                                            displayEmpty
                                            IconComponent={KeyboardArrowDownIcon}
                                            renderValue={(selected) =>
                                                !selected
                                                    ? <p className="menuItemsPlaceholder">Select By Status</p>
                                                    : statusOptions?.find((name) => name?.id === selected)?.label || ''
                                            }
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select By Status</span></MenuItem>
                                                <Tooltip
                                                    title={"Close"}
                                                    arrow
                                                >
                                                    <IconButton size="small" onClick={() => {
                                                        setOpenSelectStatus(false);
                                                    }}>
                                                        <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                            {statusOptions?.map((option) => (
                                                <MenuItem className="menuitems" key={option?.id} value={option?.id}>
                                                    {option?.label}
                                                    {option?.id === selectedStatus && (
                                                        <DoneIcon className="doneIcon" />
                                                    )}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">From Date</InputLabel>
                                        <MuiDatePicker
                                            slotProps={{
                                                textField:
                                                {
                                                    placeholder: 'Select By From Date',
                                                },
                                            }}
                                            value={filterByCreatedDate}
                                            onChange={handleFilterByCreatedDate}
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">To Date</InputLabel>
                                        <MuiDatePicker
                                            slotProps={{
                                                textField:
                                                {
                                                    size: 'small',
                                                    placeholder: 'Select By To Date',
                                                    InputProps: {
                                                        sx: { borderRadius: '10px', height: '35px' },
                                                    },
                                                },
                                            }}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px',
                                                },
                                                width: '100%'
                                            }}
                                            value={filterByToDate}
                                            onChange={handleFilterByToDate}
                                            format='DD-MM-YYYY'
                                            minDate={getNextDay(filterByCreatedDate) || null}
                                            maxDate={dayjs()}
                                            disabled={!filterByCreatedDate}
                                        />
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <MUICancelButton title='Cancel' sx={{ width: '42%' }} onClick={() => setOpen(false)} />
                            <MUIButton title='Apply' sx={{ width: '42%' }}
                                onClick={() => {
                                    setPage(1)
                                    localStorage.setItem("clientNewPage", 1);
                                    setShouldFetch(true)
                                }}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>
                {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    className="tablepagination"
                                    count={totalDataCount || 0}
                                    onPageChange={handleChangePage}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> */}

            </Grid2>
        </Box>
    )
}

export default Clients